module.exports = __webpack_public_path__ + "img/undraw_Build_wireframe_re_ln7g.b1ea0b38.svg";